import React from "react";
import { NavLink } from "react-router-dom";
import "./style.css";
export const NavItem = ({
  link,
  name,
  data,
  classes,
  icon,
  children,
  list_class,
  onClick,
  activeClassName,
}) => {
  return (
    <li className={list_class}>
      <NavLink
        to={link}
        className={classes}
        data-id={data}
        onClick={onClick && onClick}
        activeClassName={activeClassName}
      >
        {name} {icon && icon}
      </NavLink>
      {children && children}
    </li>
  );
};
